export default __webpack_public_path__ + "static/media/bd.98d594fd.svg";